import React from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { Colors } from "../colors";

const SmallBox = ({ companyName, companyNameNormalized, roleName, salary, logo, createdAt, locationCity, exp }) => {
  const navigate = useNavigate();
  const defaultLogo = "/static/images/default_company.svg";

  const handleClick = () => {
    // navigate(`/companies/${companyNameNormalized}`);  // Navigate to the company details page
  }; 

  return (
    <StyledSmallBox onClick={handleClick}>
      <ContentWrapper>
      
        <RoleName>{roleName}</RoleName>
        <Salary>
          <HugRow>
            <Currency></Currency>{salary}
          </HugRow>
        </Salary>

        <FlexRow>
          <LogoContainer>
            <Logo src={logo || defaultLogo} alt={`${companyName} logo`} />
          </LogoContainer>
          <CompanyName>{companyName}</CompanyName>
        </FlexRow>
        <YOE>⏳ {exp}</YOE>
        <FlexRow>
          <City>📍 {locationCity}</City>
        <CreatedAt>🗓️ {createdAt.slice(0, 10)}</CreatedAt>
          </FlexRow>
        
      </ContentWrapper>
    </StyledSmallBox>
  );
};

export default SmallBox;

const FlexRow = styled.div`
  display:flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`

const HugRow = styled(FlexRow)`
  direction: ltr;
`
const Currency = styled.div`
  position: aboslute;
    height: 1em;
    width: 1em;
    mask-image: url("/static/images/Saudi_Riyal_Symbol.svg");
    background-color: ${Colors.moneyGreen};
    mask-repeat: no-repeat;
    mask-size: contain;
    mask-position:center;

`
const StyledSmallBox = styled.div`
  border-radius: 12px;
  padding: 16px;
  background-color: ${Colors.white};
  box-sizing: border-box;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s ease-in-out;
  cursor: pointer;  /* Make the box visually clickable */

  &:hover {
    transform: scale(1.05);
  }
`;

const LogoContainer = styled.div`
  width: 1.5rem;
  height:1.5rem;
  border-radius: 50%;
  overflow: hidden;
  border: 2px solid ${Colors.lightGray};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

const Logo = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  margin-left: 20px;
  overflow: hidden;
  justify-content: even-space;
`;

const CompanyName = styled.div`
  font-size: 16px;
  color: ${Colors.black};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const RoleName = styled.div`
  font-size: 16px;
  padding:8px 0;
  color: ${Colors.spaceGray};
  margin-top: 5px;
  font-size: 18px;
  font-weight: bold;
  border-radius: 8px;
`;

const Salary = styled.div`
  display:flex;
  font-weight: bold;
  font-size: 20px;
  color: ${Colors.moneyGreen};
  margin-top: 5px;
  gap:8px;
  align-items: center;
`;

const City = styled.div`
  font-size: 11px;
  color: ${Colors.spaceGray};
  margin-top: 5px;
`;

const CreatedAt = styled.div`
  font-size: 11px;
  color: ${Colors.spaceGray};
  margin-top: 2px;
`;

const YOE = styled(City)`
  unicode-bidi: embed
`
